<template>
  <transition mode="out-in">
    <div v-if="loaded" class="card shadow">
      <div class="card-body">
        <h2><i class="bi bi-check-circle me-2 text-info"></i>
          You're on the list!</h2>
        <p class="lead">
          <strong>eShopCommand</strong> <em class="text-info">alpha</em> is currently at capacity, but we've saved your
          spot on the waitlist. We'll be in touch as soon as we go live or more seats open up.
        </p>
      </div>
    </div>
  </transition>
</template>
<script setup>
import { ref } from 'vue';
const loaded = ref(false);
setTimeout(() => loaded.value = true, 1000);
</script>
